import { render, staticRenderFns } from "./PrestamosHipotecarios.vue?vue&type=template&id=08adaa2f"
import script from "./PrestamosHipotecarios.vue?vue&type=script&lang=js"
export * from "./PrestamosHipotecarios.vue?vue&type=script&lang=js"
import style0 from "./PrestamosHipotecarios.vue?vue&type=style&index=0&id=08adaa2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports